import { render, staticRenderFns } from "./BankruptDetails.vue?vue&type=template&id=44d57f53"
import script from "./BankruptDetails.vue?vue&type=script&lang=js"
export * from "./BankruptDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports